import { on } from 'delegated-events'
import scrollTo from '../common/scrollTo'
import { pristineConfig } from '../components/forms'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  bookingForm: 'booking-form',
  needInterpreterRadio: 'input[name=NeedInterpreter]',
  desiredLanguages: 'BookingForm_BookingForm_DesiredLanguages_Holder',
  needInterpreterAdditional: 'BookingForm_BookingForm_NeedInterpreterAdditional_Holder',
  hasTranslatedMaterialRadio: 'input[name=HasTranslatedMaterial]',
  sendToneEmail: 'BookingForm_BookingForm_SendToneEmail_Holder',
  setupImagesTrigger: 'button.view-images',
  socialMediaCheckbox: 'BookingForm_BookingForm_SocialMediaOptions input[type=checkbox]',
  socialMediaInput: 'field.social-media-input-field input[type=text]'
})

const $form = document.querySelector(SELECTORS.asClass('bookingForm'))
const $desiredLanguages = document.getElementById(SELECTORS.desiredLanguages)
const $needInterpreterAdditional = document.getElementById(SELECTORS.needInterpreterAdditional)
const $sendToneEmail = document.getElementById(SELECTORS.sendToneEmail)
const $socialMediaOptions = document.querySelectorAll(SELECTORS.asId('socialMediaCheckbox'))
const $socialMediaInputs = document.querySelectorAll(SELECTORS.asClass('socialMediaInput'))

const fn = {
  init: () => {
    if ($form && $form.classList.contains('options-step')) {
      fn.bindEvents()
      fn.setupValidation()
    }
  },

  bindEvents: () => {
    on('change', SELECTORS.needInterpreterRadio, fn.updateNeedInterpreter)
    on('change', SELECTORS.hasTranslatedMaterialRadio, fn.updateHasTranslatedMaterial)
    on('change', SELECTORS.asId('socialMediaCheckbox'), fn.updateSocialMedia)
    fn.updateNeedInterpreter()
    fn.updateHasTranslatedMaterial()
    fn.updateSocialMedia()

    on('click', SELECTORS.setupImagesTrigger, fn.handleSetupImages)
  },

  setupValidation: () => {
    const pristine = new Pristine($form, pristineConfig)

    if ($needInterpreterAdditional) {
      pristine.addValidator(document.querySelector('[name=NeedInterpreterAdditional]'), function (value) {
        const selected = document.querySelector(`${SELECTORS.needInterpreterRadio}:checked`)

        if (!selected || selected.value !== 'Not Sure') {
          return true
        }

        return value !== ''
      }, 'This field is required', 10, false)
    }

    if ($socialMediaInputs.length) {
      $socialMediaInputs.forEach(input => {
        pristine.addValidator(input, function (value) {
          const selected = Array.from(document.querySelectorAll(`${SELECTORS.asId('socialMediaCheckbox')}:checked`)).map(i => i.value)

          if (selected.indexOf(input.dataset.type) === -1) {
            return true
          }

          return value !== ''
        }, 'This field is required', 10, false)
      })
    }

    $form.addEventListener('submit', (e) => {
      if (e.target.skipValidation) {
        return true
      }

      const valid = fn.validateCustom() && pristine.validate()

      if (!valid) {
        e.preventDefault()
        const $firstError = $form.querySelector('.field.has-error')

        if ($firstError) {
          scrollTo($firstError, 150, () => $firstError.querySelector('input') && $firstError.querySelector('input').focus())
        }

        return false
      }
    })
  },

  updateNeedInterpreter: () => {
    const selected = document.querySelector(`${SELECTORS.needInterpreterRadio}:checked`)

    if (!$desiredLanguages) {
      return
    }

    $desiredLanguages.style.display = 'none'
    $needInterpreterAdditional.style.display = 'none'

    if (selected) {
      if (selected.value === 'Yes') {
        $desiredLanguages.style.display = 'block'
      } else {
        $desiredLanguages.querySelectorAll('input:checked').forEach(i => i.checked = false)
      }

      if (selected.value === 'Not Sure') {
        $needInterpreterAdditional.style.display = 'block'
      } else {
        $needInterpreterAdditional.querySelector('textarea').value = null
      }
    }
  },

  updateHasTranslatedMaterial: () => {
    const selected = document.querySelector(`${SELECTORS.hasTranslatedMaterialRadio}:checked`)

    if (!$sendToneEmail) {
      return
    }

    $sendToneEmail.style.display = 'none'

    if (selected) {
      if (selected.value === '0') {
        $sendToneEmail.style.display = 'block'
      } else {
        $sendToneEmail.querySelectorAll('input:checked').forEach(i => i.checked = false)
      }
    }
  },

  updateSocialMedia: () => {
    if (!$socialMediaOptions.length) {
      return
    }

    $socialMediaOptions.forEach(o => {
      const $inputFieldHolder = document.querySelector(`.field.social-media-input-field.${o.value}`)

      if (o.checked) {
        $inputFieldHolder.style.display = 'block'
      } else {
        $inputFieldHolder.style.display = 'none'
        $inputFieldHolder.querySelector('input[type=text]').value = null
      }
    })
  },

  handleSetupImages: (e) => {
    const lightGallery = window.lightGallery

    lightGallery(e.target, {
      dynamic: true,
      dynamicEl: JSON.parse(e.target.dataset.images),
      download: true,
      thumbnail: false
    })
  },

  validateCustom: () => {
    const $radioGroups = document.querySelectorAll('ul.optionset[aria-required=true], ul.optionsetdescription[aria-required=true], ul.optionsetdescriptionimages[aria-required=true]')
    let valid = true

    $radioGroups.forEach($group => {
      const selected = $group.querySelector('input:checked')

      $group.closest('.field').querySelectorAll('.pristine-error').forEach(i => i.remove())
      $group.closest('.field').classList.remove('has-error')

      if (!selected) {
        $group.closest('.field').classList.add('has-error')
        valid = false

        const $errorEl = document.createElement('div')
        $errorEl.className = 'pristine-error'
        $errorEl.innerHTML = 'Please select an option'
        $group.closest('.field').appendChild($errorEl)
      }
    })

    if ($desiredLanguages) {
      $desiredLanguages.querySelectorAll('.pristine-error').forEach(i => i.remove())
      $desiredLanguages.classList.remove('has-error')

      const selectedNeedInterpreter = document.querySelector(`${SELECTORS.needInterpreterRadio}:checked`)
      if (selectedNeedInterpreter && selectedNeedInterpreter.value === 'Yes' && !$desiredLanguages.querySelectorAll('input:checked').length) {
        $desiredLanguages.classList.add('has-error')
        valid = false

        const $errorEl = document.createElement('div')
        $errorEl.className = 'pristine-error'
        $errorEl.innerHTML = 'Please select an option'
        $desiredLanguages.appendChild($errorEl)
      }
    }

    return valid
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingrequestpage'),
  run: fn.init
}
